import { Palette } from '@mui/icons-material';
import { IconButton, Popover, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React, { useState } from 'react';

import ThemeEditor, { type ThemeEditorProps } from './ThemeEditor';

interface ThemeEditorPopoverProps extends ThemeEditorProps {
    className?: string;
}

export default function ThemeEditorPopover({ className, size, showSettingsLink }: ThemeEditorPopoverProps) {
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <>
            <IconButton
                onClick={handleClick}
                sx={{
                    color: theme.palette.primary.main,
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                        backgroundColor: alpha(theme.palette.primary.main, 0.1),
                        transform: 'scale(1.05)',
                    },
                }}
            >
                <Palette />
            </IconButton>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <ThemeEditor showSettingsLink={showSettingsLink} size={size} />
            </Popover>
        </>
    );
}
